import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Button, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import { CHUONGTRINHHOC_API, CHUYENNGANH_API } from '@app/utils/apiUrl';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../utils/helper';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { messageToast, objectShowNumber, status200, styleSelectDefault } from '../../../../utils/define';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import { AsyncPaginate } from 'react-select-async-paginate';

const ChuongTrinhHoc = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [chuyenNganhId, setChuyenNganhId] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const replaceHistory = (Page, Size, Search, ChuyenNganhId) => {
        const params = {
            page: Page,
            size: Size,
            search: Search || ''
        };

        if (ChuyenNganhId) {
            params.chuyenNganhId = ChuyenNganhId;
        }

        history.replace(
            createUrlWithParam(URI_INTERNAL.CHUONGTRINHHOC_PATH, params)
        );
    };

    useEffect(() => {
        const paramUrl = new URLSearchParams(location.search.substring(1));
        const pageParam = parseInt(paramUrl.get('page'), 10);
        const sizeParam = parseInt(paramUrl.get('size'), 10);
        const searchParam = paramUrl.get('search');
        const chuyenNganhIdParam = paramUrl.get('chuyenNganhId') || '';

        if (!Number.isNaN(pageParam) && pageParam !== page) {
            setPage(pageParam);
        }
        if (!Number.isNaN(sizeParam) && sizeParam !== pageSize) {
            setPageSize(sizeParam);
        }
        if (searchParam != null && searchParam !== search) {
            setSearch(searchParam);
        }
        if (chuyenNganhIdParam !== (chuyenNganhId || '')) {
            setChuyenNganhId(chuyenNganhIdParam);
        }
    }, [location.search]);

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['chuongTrinhHocData', valueSearch, page, pageSize, chuyenNganhId],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize
            };
            if (chuyenNganhId) {
                model.ChuyenNganhId = chuyenNganhId;
            }
            replaceHistory(page, pageSize, valueSearch, chuyenNganhId);
            return Get(CHUONGTRINHHOC_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, chuyenNganhId]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch, chuyenNganhId);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, chuyenNganhId);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, chuyenNganhId);
    };

    // const onChangeChuyenNganh = (e) => {
    //     setPage(1);
    //     setChuyenNganhId(e.target.value);
    //     replaceHistory(1, pageSize, search, e.target.value);
    // };

    const deleteFunc = useMutation((value) => DeleteSingle(CHUONGTRINHHOC_API.DELETE_ITEM, value, null));

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (idWantDelete === '') return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const loadOptionsChuyenNganh = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(CHUYENNGANH_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.maChuyenNganh} - ${x.tenChuyenNganh}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    return (
        <div className="container-fluid">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>Danh mục chương trình học</h5>
                        <div className="d-flex">
                            <NavLink to={URI_INTERNAL.CHUONGTRINHHOC_CREATE_PATH} className="btn btn-success">
                                Thêm mới
                            </NavLink>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <span style={{ marginLeft: '20px' }}>
                                <AsyncPaginate
                                    name="chuyenNganhId"
                                    id="chuyenNganhId"
                                    placeholder="Chọn chuyên ngành"
                                    value={chuyenNganhId?.value}
                                    loadOptions={loadOptionsChuyenNganh}
                                    styles={styleSelectDefault}
                                    isClearable
                                    onChange={(selectedOption) => {
                                        setPage(1);
                                        setChuyenNganhId(selectedOption?.value || '');
                                        replaceHistory(1, pageSize, search, selectedOption?.value || '');
                                    }}
                                    additional={{
                                        page: 1
                                    }}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Tên chương trình học</th>
                                    <th>Chuyên ngành</th>
                                    <th>Mô tả</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={5}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={5}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => {
                                        return (
                                            <tr key={item.id || index}>
                                                <td>{(page - 1) * pageSize + index + 1}</td>
                                                <td>{item.tenChuongTrinhHoc || item.TenChuongTrinhHoc}</td>
                                                <td>{item.chuyenNganh?.tenChuyenNganh || item.chuyenNganh?.TenChuyenNganh || ''}</td>
                                                <td>
                                                    <div className="desc">
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: item.moTa || item.MoTa || '-'
                                                            }}
                                                        ></span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <NavLink
                                                        className="btn btn-primary btn-sm mr-2"
                                                        to={`${URI_INTERNAL.CHUONGTRINHHOC_EDIT_PATH}?id=${item.id}`}>
                                                        Sửa
                                                    </NavLink>
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => deleteAction(item.id, item.tenChuongTrinhHoc || item.TenChuongTrinhHoc)}>
                                                        Xóa
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        handleAccept={acceptDelete}
                        handleCancel={cancelDelete}
                        content={confirmDelMessage}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default ChuongTrinhHoc;
